module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone_lock_modal.title":"เปลี่ยนสถานะการ Lock Drone","drone.field.lock_state.help":"ปรับสถานะการ Lock Drone เนื่องจาก Finance Problem"}}')
  delete Component.options._Ctor
}
